import { makePostRequest } from 'owa-ows-gateway';

const POST_WEB_PUSH_SUBSCRIPTION_URL: string = 'ows/beta/webpushsubscriptions/delete';

export default function unregisterEndpoint(endPoint: string, clientId?: string): Promise<boolean> {
    let request: UnregisterEndpointRequest = { endpoint: endPoint, clientId: clientId };
    return makePostRequest(POST_WEB_PUSH_SUBSCRIPTION_URL, request).then(function(
        response: UnregisterEndpointResponse
    ) {
        if (response.unregistered === true) {
            return Promise.resolve(true);
        } else {
            throw new Error('Failed to unregister endpoint.');
        }
    });
}
